import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconQuit = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" {...props}>
    <path d="M11.7515 21.25L17.0001 16L11.7515 10.75" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 16H16.9963" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 5H24C24.2652 5 24.5196 5.10536 24.7071 5.29289C24.8946 5.48043 25 5.73478 25 6V26C25 26.2652 24.8946 26.5196 24.7071 26.7071C24.5196 26.8946 24.2652 27 24 27H17"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconQuit;
